import { render, staticRenderFns } from "./rightContentRender.vue?vue&type=template&id=7edb5e11&"
import script from "./rightContentRender.vue?vue&type=script&lang=ts&"
export * from "./rightContentRender.vue?vue&type=script&lang=ts&"
import style0 from "./rightContentRender.vue?vue&type=style&index=0&id=7edb5e11&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports